import { Box, Flex } from '@chakra-ui/react';
import { FormControl, Text } from 'components/ui';
import { Link } from '../ui/Link';

export const TOSInput = ({ tosChecked, submitted, handleTosChange }) => {
  const links = [
    {
      href: 'https://www.ayblehealth.com/terms-of-service',
      text: 'Terms of Service',
      end: ', ',
    },
    {
      href: 'https://www.ayblehealth.com/medical-terms-of-service',
      text: 'Medical Terms of Service',
      end: ', ',
    },
    {
      href: 'https://www.ayblehealth.com/privacy-policy',
      text: 'Privacy Policy',
      end: ', and ',
    },
    {
      href: 'https://www.ayblehealth.com/notice-of-privacy-practices',
      text: 'Notice of HIPAA Privacy Practices',
      end: '.',
    },
  ];

  return (
    <form name="tosForm">
      <FormControl invalid={!tosChecked && submitted}>
        <Flex direction="row" align="flex-start" gap="10px">
          <input
            type="checkbox"
            name="TOS"
            id="TOS"
            checked={tosChecked}
            onChange={handleTosChange}
            data-testid="tos-checkbox"
            style={{
              width: '19px',
              height: '19px',
              marginTop: '2px',
              flexShrink: 0,
              accentColor: '#2D6670',
            }}
          />

          <Box flex={1} maxW="450px">
            {/* App.css sets `label { font-size: 15px }` with no line-height,
                and that strut wins over our inline Text, so pin both here. */}
            <label
              htmlFor="TOS"
              style={{ fontSize: '14px', lineHeight: 1.4, margin: 0 }}
            >
              <Text
                as="span"
                color="secondary.500"
                textStyle="body.check"
              >
                By continuing, I agree that I am at least 18 years old and agree
                to Ayble's{' '}
                {links.map((link, index) => (
                  <Box key={index} as="span" display="inline">
                    <Link
                      color="aqua.500"
                      display="inline"
                      fontWeight={600}
                      textDecoration="none"
                      href={link.href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {link.text}
                    </Link>
                    {link.end}
                  </Box>
                ))}
              </Text>
            </label>
          </Box>
        </Flex>
      </FormControl>
    </form>
  );
};

export default TOSInput;
